import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';

const styles = theme => ({
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  description: {
    display: 'block',
    fontSize: 24,
    marginBottom: 20,
    fontWeight: 400
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    padding: theme.spacing(2)
  },
  detailTable: {
    width: 500
  },
  dialogReceipt: {
    width: 600
  },
  flexStart: {
    justifyContent: 'flex-start',
    padding: '10px 16px'
  }
});

const enhance = compose();

const Main = enhance(
  ({
    openChangeConfirm,
    updateOpenChangeConfirm,
    cancelAction,
    changeAction,
    classes,
    useReceipt,
    editInput,
    ocrShopId
  }) => {
    const actionChage = value => {
      const paramsChange = {
        editInput,
        useReceipt: value,
        ocrShopId
      };
      changeAction(paramsChange);
    };
    return (
      <Dialog
        open={openChangeConfirm}
        onClose={() => {
          updateOpenChangeConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.dialogReceipt}>
          <Typography component="h4" className={classes.description}>
            レシート利用機能 確認
          </Typography>
          <Paper className={classes.paper} elevation={1}>
            <Table className={classes.detailTable}>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    レシート利用機能
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {parseInt(useReceipt, 10) === 1 ? '利用する' : '利用しない'}
                    に変更
                  </TableCell>
                </TableRow>

                {parseInt(useReceipt, 10) === 1 && editInput && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        店舗名
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editInput.shopName}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        銀行名
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editInput.bankName}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        支店名
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editInput.bankBranchName}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        口座番号
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editInput.bankAccountNumber}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        口座名義
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editInput.bankAccountHolder}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellItem}>
                        口座種別
                      </TableCell>
                      <TableCell className={classes.tableCellData}>
                        {editInput.bankAccountTypeStr}
                      </TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </Paper>
        </DialogContent>
        <DialogActions className={classes.flexStart}>
          <CancelButton
            onClickAction={cancelAction}
            color="default"
            btnText="戻る"
          />
          <ChangeButton
            onClickAction={() => actionChage(useReceipt)}
            btnText="確認"
          />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
